import React, { useEffect, useState } from "react";

import { Button } from "antd";
import { useLocation } from "react-router";
import { toast } from "react-toastify";

import LoginInput from "./Common/LoginInput";

import { validatePassword } from "../Common/utils/validationUtils";

import { resetPassword } from "../../actions/login";

import genistaLogo from "../../assets/images/logo/genista-logo.svg";
import loginBgIcon from "../../assets/images/logo/login-bg-img.svg";
import loginMainIcon from "../../assets/images/logo/login-main-img.svg";

import "./login.css";
import "./ResetPassword.css";

export default function ResetPassword({ history }) {
  const [email, setEmail] = useState("");
  const [oobCode, setOobCode] = useState(""); // string. A verification code sent via email to the user when it clicks reset.
  const [password, setPassword] = useState("");
  const [confirmedPassword, setConfirmedPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();

  // componentDidMount - parse firebase code and email from url */
  // useEffect(() => {
  //   const params = new URLSearchParams(search);
  //   const oobCode = params.get("oobCode");
  //   if (oobCode) {
  //     firebaseAuth.verifyPasswordResetCode(oobCode)
  //       .then((userEmail) => {
  //         setFirebaseCode(oobCode);
  //         setEmail(userEmail);
  //       })
  //       .catch(() => {
  //         /** Link expired or was already used, redirect to invalid page */
  //         history.push("/resetpassword/invalid");
  //       });
  //   } else {
  //     history.push("/resetpassword/invalid");
  //   }
  // }, []); // eslint-disable-line

  /** componentDidMount - parse oobCode from url */
  useEffect(() => {
    const params = new URLSearchParams(search);
    const code = params.get("oobCode");
    if (code) {
      setOobCode(code);
      // Email will be set from API response after successful reset
    } else {
      history.push("/resetpassword/invalid");
    }
    // Commented out Firebase implementation
    // firebaseAuth.verifyPasswordResetCode(oobCode)
    //   .then((userEmail) => {
    //     setFirebaseCode(oobCode);
    //     setEmail(userEmail);
    //   })
    //   .catch(() => {
    //     /** Link expired or was already used, redirect to invalid page */
    //     history.push("/resetpassword/invalid");
    //   });
  }, [search, history]);

  const onSubmit = () => {
    let atLeastOneMissing = false;
    if (!password) {
      setPasswordError(true);
      atLeastOneMissing = true;
    }
    if (!confirmedPassword) {
      setConfirmPasswordError(true);
      atLeastOneMissing = true;
    }
    if (atLeastOneMissing) {
      return;
    }

    if (!validatePassword(password)) {
      toast.error("Password does not meet the requirements.");
    } else if (password !== confirmedPassword) {
      toast.error("Those passwords didn't match. Try again.");
    } else {
      setLoading(true);
      // Commented out Firebase implementation
      // firebaseAuth.confirmPasswordReset(firebaseCode, password)
      //   .then(() => {
      //     setLoading(false);
      //     history.push("./resetpassword/success");
      //   })
      //   .catch((error) => {
      //     setLoading(false);
      //     if (error.code === "auth/expired-action-code" || error.code === "auth/invalid-action-code") {
      //       history.push("/resetpassword/invalid");
      //     } else {
      //       toast.error("Failed to reset password. Try again.");
      //     }
      //   });

      // Direct API call implementation
      resetPassword(oobCode, password, (result) => {
        setLoading(false);
        if (result.success) {
          // Set email from response if available
          if (result.email) {
            setEmail(result.email);
          }
          history.push("./resetpassword/success");
        } else if (result.message?.toLowerCase().includes("expired")
              || result.message?.toLowerCase().includes("invalid")) {
          // Handle expired or invalid code
          history.push("/resetpassword/invalid");
        } else {
          toast.error(result.message || "Failed to reset password. Try again.");
        }
      });
    }
  };

  const handleChangPsw = (e) => {
    setPassword(e.target.value);
  };

  const handleChangeConfirmPsw = (e) => {
    setConfirmedPassword(e.target.value);
  };

  // Removed email check since we might not have it initially (will be set from API response)
  // if (!email) return null;

  return (
    <div className="login-page">
      <img
        src={genistaLogo}
        alt="Genista"
        className="logoLoginPage"
        onClick={() => history.push("/login")}
        role="link"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            history.push("/login");
          }
        }}
      />

      <div className="loginMainContainer">
        <form className="login-box">
          <div className="login-header">
            Reset password
          </div>
          {email && (
            <div className="reset-password-subtitle">
              <span>for </span>
              <span className="reset-password-email">{email}</span>
            </div>
          )}
          <LoginInput
            label="Password"
            isPassword
            id="reset-password"
            name="password"
            value={password}
            onChange={handleChangPsw}
            error={passwordError}
            clearError={() => setPasswordError(false)}
          />
          <div className="reset-password-require">Must contain: at least 1 number, 1 uppercase, 1 lowercase letter, at least 6 characters, no spaces.</div>
          <LoginInput
            label="Password"
            isPassword
            id="reset-password-confirm"
            name="password"
            value={confirmedPassword}
            onChange={handleChangeConfirmPsw}
            error={confirmPasswordError}
            clearError={() => setConfirmPasswordError(false)}
            onEnter={onSubmit}
          />

          <div className="reset-password-btn-container login-button-container">
            <Button
              type="primary"
              className="reset-password-btn login-btn"
              onClick={() => onSubmit()}
              disabled={loading}
              loading={loading}
            >
              Submit
            </Button>
          </div>
        </form>

        <div className="loginImage">
          <img
            className="loginImageBubbles"
            src={loginBgIcon}
            alt="login"
          />
          <img
            className="loginImageCharacters"
            src={loginMainIcon}
            alt="login"
          />
        </div>
      </div>
    </div>
  );
}
